import { render } from "./downloadapp.vue?vue&type=template&id=4edfacf4"
import script from "./downloadapp.vue?vue&type=script&lang=js"
export * from "./downloadapp.vue?vue&type=script&lang=js"

import "./downloadapp.vue?vue&type=style&index=0&id=4edfacf4&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__